// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__17Zbo","errors":"Errors_errors__1ZDzc"};